<sign-title-adjustment-overview [sign]="sign"></sign-title-adjustment-overview>

<div class="table-upper-margin">
  <sign-phone-number-adjustment-overview
    [sign]="sign"
  ></sign-phone-number-adjustment-overview>
</div>

<div class="table-upper-margin">
  <sign-sticker-overview [sign]="sign"></sign-sticker-overview>
</div>
